module.exports = __webpack_public_path__ + "img/dragon-bg.d9501a81.webp";